import { Flex, SelectField, Typography } from '@iheartjane/reefer';

import { useFetchBloomMenus } from '@jane/business-admin/data-access';

import { CopyLink } from './CopyLink';

interface MenuSelectorProps {
  currentMenuId?: string;
  onChange: (newId: string) => void;
}

export const MenuSelector = ({
  currentMenuId,
  onChange,
}: MenuSelectorProps) => {
  const { data: bloomMenus } = useFetchBloomMenus();

  const currentMenuToken = bloomMenus?.find(
    (menu) => menu.id === Number(currentMenuId)
  )?.menu_token;

  return (
    <Flex flexDirection="column" mb={40}>
      <SelectField
        mt={24}
        ml={40}
        mr={40}
        name="bloom-menus"
        label="bloom-menus"
        labelHidden
        required
        value={currentMenuId}
        onChange={onChange}
        options={(bloomMenus ?? []).map(({ menu_url, id }) => ({
          label: `${menu_url}`,
          value: `${id}`,
        }))}
      />
      <Flex
        flexDirection="row"
        mt={8}
        justifyContent="space-between"
        ml={40}
        mr={40}
      >
        <Typography as="p" color="grays-mid" mr={16}>
          Token: {currentMenuToken}
        </Typography>
        <CopyLink
          ariaLabel="Copy menu token"
          label="Copy token"
          value={currentMenuToken}
        />
      </Flex>
    </Flex>
  );
};
